import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import ToggleButton from '@mui/material/ToggleButton';

import { DraggableDialog } from '../../DraggablePaper/DraggablePaper';
import ModalFormTitle from '../../Tables/TableWithModalEdit/modalFormPieces/ModalFormTitle';
import useUserPreferences from '../../../hooks/useUserPreferences';
import { FONT_SIZES_OP, FONT_WEIGHTS_OP, GRID_DENSITY_OP } from './tableSettings.constants';
import { SettingsGroupStyled } from './styles/tableSettings.styles';

type TableSettingsDialogProps = { open: boolean; onClose: () => void };
export default function TableSettingsDialog({ open, onClose }: TableSettingsDialogProps) {
    const { preferences, update } = useUserPreferences();

    return (
        <DraggableDialog
            open={open}
            onClose={onClose}
            hideBackdrop
            disableEnforceFocus
            maxWidth={false}
            PaperProps={{ sx: { width: 240, borderRadius: '10px' } }}
        >
            <ModalFormTitle
                title="Table Settings"
                toggleDialog={onClose}
                titleBarStyle={{ padding: '6px 12px 6px 16px' }}
            />
            <DialogContent sx={{ px: 1.5, pt: 0, pb: 1.5, '&:last-child': { pb: 1.5 } }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                    Density
                </Typography>
                <SettingsGroupStyled
                    value={preferences.gridDensity}
                    exclusive
                    size="small"
                    fullWidth
                    onChange={(_, val) => val && update({ gridDensity: val })}
                >
                    {GRID_DENSITY_OP.map(({ value, label }) => (
                        <ToggleButton key={value} value={value}>
                            {label}
                        </ToggleButton>
                    ))}
                </SettingsGroupStyled>

                <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                    Font Size
                </Typography>
                <SettingsGroupStyled
                    value={preferences.fontSize}
                    exclusive
                    size="small"
                    fullWidth
                    onChange={(_, val) => val && update({ fontSize: val })}
                >
                    {FONT_SIZES_OP.map(({ value, label }) => (
                        <ToggleButton key={value} value={value}>
                            {label}
                        </ToggleButton>
                    ))}
                </SettingsGroupStyled>

                <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.7rem' }}>
                    Font Weight
                </Typography>
                <SettingsGroupStyled
                    value={preferences.fontWeight || 'normal'}
                    exclusive
                    size="small"
                    fullWidth
                    onChange={(_, val) => val && update({ fontWeight: val })}
                >
                    {FONT_WEIGHTS_OP.map(({ value, label, weight }) => (
                        <ToggleButton key={value} value={value} sx={{ fontWeight: weight }}>
                            {label}
                        </ToggleButton>
                    ))}
                </SettingsGroupStyled>
            </DialogContent>
        </DraggableDialog>
    );
}
